module.exports = __webpack_public_path__ + "img/ico-presale.f41f5a40.svg";